import { FlowTemplateId } from "../../constants/flowTemplates";
import {
  DepositFundManualTemplate,
  DepositFundSearchTemplate,
  FlowTemplateProps,
} from "./DepositFundTemplate";
import {
  SchoolFeeManualTemplate,
  SchoolFeeRegistrationTemplate,
  SchoolFeeSearchTemplate,
} from "./SchoolFeeTemplate";

export type { FlowTemplateProps };

// The other half of 16-20's registry. That one is pure data and maps a
// discriminator to an IDENTIFIER, because constants/ may not import components/;
// this one turns the identifier into the module that draws it.
//
// ✅ TOTAL since 12-09: every identifier the registry can produce has a module
// here. It was Partial while SCHOOLFEE_MANUAL and SCHOOLFEE_REGISTRATION were
// unbuilt, and the type is now the check -- adding an id to FLOW_TEMPLATE_IDS
// without a module stops compiling rather than falling a live payer back to
// the deprecated, deposit-shaped page.
export const FLOW_TEMPLATE_COMPONENTS: Record<
  FlowTemplateId,
  React.ComponentType<FlowTemplateProps>
> = {
  DEPOSITFUNDS_MANUAL: DepositFundManualTemplate,
  DEPOSITFUNDS_SEARCH: DepositFundSearchTemplate,
  SCHOOLFEE_SEARCH: SchoolFeeSearchTemplate,
  SCHOOLFEE_MANUAL: SchoolFeeManualTemplate,
  SCHOOLFEE_REGISTRATION: SchoolFeeRegistrationTemplate,
};

export {
  DepositFundManualTemplate,
  DepositFundSearchTemplate,
  SchoolFeeSearchTemplate,
  SchoolFeeManualTemplate,
  SchoolFeeRegistrationTemplate,
};
